import Crud from './crud'
import { request_list, export_list } from '@/commons/hpod';
import Vue from 'vue';
var FileSaver = require('file-saver');
var crud = new Crud('bills', 'xuất kho');

const state = {
    ...crud.state,
    bill_detail: {},
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getDetailList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('products', data => {
            commit('setDetailList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    exportList({ commit }, param) {
        export_list('bills', res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `XuatKho_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
};
const mutations = {
    ...crud.mutations,
    setDetailList(state, data) {
        state.bill_detail = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};